<template>
    <div>
      <div v-if="loading"></div>
      <!-- <h3>{{ errorMessage }}</h3> -->
      <h3 v-if="!selectedTenant">
        <!--Total {{counts}} Tenants-->
        <div class="container-fluid p-0 bodyArea">
          <div class="containerBox">
            <div class="pageHeader row m-0 align-items-center">
              <div class="col">Total Tenants : {{ counts }}</div>
              <div class="col text-right tfilters p-0">
                <div class="filterWrapper">
                  <div class="filterText">Filter:</div>
  
                  <input v-model="filterString" type="text" maxlength="20" class="filterInputText" />
                  <!-- <a class="dropdown-toggle filterDropDown" href="javascript:void(0)" role="button" id="tenantsDropDownLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{filterString}}</a>
                            <div class="dropdown-menu filterDropDownData" aria-labelledby="tenantsDropDownLink">
          
                              <a class="dropdown-item active" href="javascript:void(0)" v-for="tenant in tenants" v-bind:key="tenant">{{ getName(tenant) }}</a>
                            
                  </div>-->
  
                  <!-- <div class="dropdown col p-0">
                          <a class="dropdown-toggle filterDropDown" href="javascript:void(0)" role="button" id="tenantsDropDownLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{filterString}}</a>
                          <div class="dropdown-menu filterDropDownData" aria-labelledby="tenantsDropDownLink">
                            <a class="dropdown-item " href="javascript:void(0)">All</a>
  
                            <a class="dropdown-item " href="javascript:void(0)" v-for="tenant in tenants.filter(function(x){if(filterString != null && filterString.trim().length > 0){ return x.name.toLowerCase().indexOf(filterString.toLowerCase())>=0 || x.fullName.toLowerCase().indexOf(filterString.toLowerCase())>=0; } return true;})" v-bind:key="tenant"
                              :value="tenant.value"  @click.prevent="selectedTenantName = tenant.text" >{{ tenant.text }}>{{ getName(tenant.text) }}</a>
                            
                          </div>
                  </div>-->
                </div>
  <!--              <div>-->
  <!--                <div class="actionBtn clientShowBtn" id="btnCreateTenant" @click="showTenantModal()">-->
  <!--                  Create Tenant-->
  <!--                </div>-->
  <!--              </div>-->
              </div>
            </div>
          </div>
        </div>
      </h3>
      <div v-if="!loading && !selectedTenant">
        <!--Filter: <input v-model="filterString" type="text" maxlength="20"/> <br/><br/>-->
        <div v-if="viewSubmissionList == false" class="pageDataWrapper pageActualDataWrapper">
          <div class="contentHeader row m-0 align-items-center">
            <div class="col">
              <img src="../../assets/images/tenantsHeaderIcon.svg" width="16" />&nbsp;&nbsp;Tenant Name
            </div>
            <div class="col flex-3">
              <img src="../../assets/images/urlIcon.svg" width="16" />&nbsp;&nbsp;Urls
            </div>
            <div class="col flex-2">
              <img src="../../assets/images/licenseIcon.svg" width="16" />&nbsp;&nbsp;License Keys
            </div>
            <div class="col flex-2">
              <img src="../../assets/images/licenseIcon.svg" width="16" />&nbsp;&nbsp;Release Versions
            </div>
            <div class="col">
              <img src="../../assets/images/licenseIcon.svg" width="16" />&nbsp;&nbsp;Actions
            </div>
            <!-- <div class="col-2"><img src="../assets/images/reportsIcon.svg" width="16">&nbsp;&nbsp;Reports</div> -->
          </div>
          <div class="contentDataWrap">
            <div v-for="tenant in tenants.filter(function (x) {
              if (filterString != null && filterString.trim().length > 0) {
                return (
                  x.name.toLowerCase().indexOf(filterString.toLowerCase()) >=
                  0 ||
                  x.fullName
                    .toLowerCase()
                    .indexOf(filterString.toLowerCase()) >= 0 ||
                  x.version.toLowerCase().indexOf(filterString.toLowerCase()) >= 0
                );
  
              }
              return true;
            })" v-bind:key="tenant.name">
              <div class="
                                                      contentDataWrapper
                                                      actions
                                                      contentActualDataWrapper
                                                      row
                                                      m-0
                                                    ">
                <div class="contentData row m-0 align-items-center col-12 p-0" v-bind:key="tenant.name"
                  :id="tenant.name + '_report'" :value="tenant.name + '+' + tenant.fullName">
                  <div class="col">{{ getName(tenant) }}</div>
  
                  <div class="col flex-3">
                    <span v-html="getRoutes(tenant.routes, 'ROUTES_URL')"></span>
                  </div>
                  <div class="col flex-2">
                    <span v-html="getRoutes(tenant.routes, 'ROUTES_LICENSE_KEY')"></span>
                  </div>
  
                  <!-- <div v-on:click="getVersion(tenant)" class="col flex-2"> -->
                  <div v-on:click="getVersion(tenant)" class="col flex-2">
                    <div>
                      <span class="version-link" @mouseover="hover = true" @mouseout="hover = false">
                        {{ tenant.version }}</span>
                      <!-- <div v-if="releaseVersions && releaseVersions.find(e => e.tenants.includes(tenant.name))">
                        <span class="version-link" @mouseover="hover = true" @mouseout="hover = false">{{
                          releaseVersions.find(e => e.tenants.includes(tenant.name)).version }}</span>
                      </div>
                      <div
                        v-if="releaseVersions && !releaseVersions.find(e => e.tenants.includes(tenant.name)) && releaseVersions.find(e => e.defaultRelease === true)">
                        <span class="version-link" @mouseover="hover = true" @mouseout="hover = false">{{
                          releaseVersions.find(e => e.defaultRelease === true).version }}</span>
                      </div> -->
                    </div>
                  </div>
  
                  <div class="dropdown dropdownAction col row m-0 align-items-center">
                    <!--  <p v-if="commandError != null  && commandError.length > 0" class="smallFont" style="color:red">* {{commandError}}</p> -->
  
                    <a class="dropdown-toggle actionDropDown" href="javascript:void(0)" role="button"
                      id="actionDropDownLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</a>
                    <div class="dropdown-menu actionDropDownData dropdown-menu-left" aria-labelledby="actionDropDownLink">
                      <div class="actionWrapper row m-0">
                        <!-- Commented Action Tenant Features as per the IDA- 3145-->
                        <!-- <div class="actionWrapperRow row m-0 col-12" @click="enableRuleSettings(tenant)">
                          <div class="col-9 actionWrapperRowHeading p-0">
                            Activate Tenant Features
                          </div>
                          <div class="col-3 p-0 text-right">
                            <div disabled="true" class="actionBtn" id="btnSendOnboarding">
                              <img src="../assets/images/edit.svg" width="16" />
                            </div>
                          </div>
                        </div> -->
                        <!-- <div class="actionWrapperRow row m-0 col-12">
                            <div class="col-7 actionWrapperRowHeading p-0">Form-Fields</div>
                            <div class="col-5 p-0 text-right">
                            <div
                               class="actionBtn clientShowBtn"
                              id="btnUpdateFormField"
                              @click="updateForm(tenant)"
                              >update
                              </div>
                              </div>
                        </div> -->
                        <div class="actionWrapperRow row m-0 col-12" @click="openWebSettings(tenant)">
                          <div class="col-9 actionWrapperRowHeading p-0">
                            IDA Web Settings
                          </div>
                          <div class="col-3 p-0 text-right">
                            <div disabled="true" class="actionBtn" id="btnSendOnboarding">
                              <img src="../../assets/images/edit.svg" width="16" />
                            </div>
                          </div>
                        </div>
                        <div class="actionWrapperRow row m-0 col-12" @click="openQuestionnaireSettings(tenant)">
                          <div class="col-9 actionWrapperRowHeading p-0">
                            Smart Entry Settings
                          </div>
                          <div class="col-3 p-0 text-right">
                            <div disabled="true" class="actionBtn" id="btnSendOnboarding">
                              <img src="../../assets/images/edit.svg" width="16" />
                            </div>
                          </div>
                        </div>
  
                        <div class="actionWrapperRow row m-0 col-12" @click="openMobileSettings(tenant)">
                          <div class="col-9 actionWrapperRowHeading p-0">
                            IDA Mobile Settings
                          </div>
                          <div class="col-3 p-0 text-right">
                            <div disabled="true" class="actionBtn" id="btnSendOnboarding">
                              <img src="../../assets/images/edit.svg" width="16" />
                            </div>
                          </div>
                        </div>
  <!--                      <div class="actionWrapperRow row m-0 col-12" @click="samlConnectionSetup(tenant)">-->
  <!--                        <div class="col-9 actionWrapperRowHeading p-0">-->
  <!--                          New SAML Connection Setup-->
  <!--                        </div>-->
  <!--                        <div class="col-3 p-0 text-right">-->
  <!--                          <div disabled="true" class="actionBtn" id="btnSendOnboarding">-->
  <!--                            <img src="../assets/images/edit.svg" width="16" />-->
  <!--                          </div>-->
  <!--                        </div>-->
  <!--                      </div>-->
                        <div class="actionWrapperRow row m-0 col-12" @click="tvConfigurationSetup(tenant)">
                          <div class="col-9 actionWrapperRowHeading p-0">
                            TV Configuration Settings
                          </div>
                          <div class="col-3 p-0 text-right">
                            <div disabled="true" class="actionBtn" id="btnSendOnboarding">
                              <img src="../../assets/images/edit.svg" width="16" />
                            </div>
                          </div>
                        </div>
  
                        <!-- <div class="actionWrapperRow row m-0 col-12">
                          <div class="col-7 actionWrapperRowHeading p-0">Onboarding</div>
                          <div class="col-5 p-0 text-right">
                            <div
                              class="actionBtn clientShowBtn"
                              id="btnSendOnboarding"
                              @click="openModal(tenant)"
                            >Send</div>
                          </div>
                        </div> -->
                        <!-- <div class="actionWrapperRow row m-0 col-12">
                          <div class="col-7 actionWrapperRowHeading p-0">Submission</div>
                          <div class="col-5 p-0 text-right">
                            <div
                              class="actionBtn clientShowBtn"
                              id="btnViewSubmit"
                              @click="showViewSubmission(tenant)"
                            >View</div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- start -->
          <b-modal v-model="showformFieldCreationDialog" id="updateFormFields" hide-backdrop centered
            v-bind:title="covidFormFieldsTitle" ok-title="Send" @ok="sendFormFields"
            @hidden="showformFieldCreationDialog = false" @cancel="showformFieldCreationDialog = false">
            <b-form ref="form">
              <b-form-group label="Identity Type">
                <!-- <b-form-input id="identityType" value v-model="sendFormFieldDocument.identityType"></b-form-input> -->
                <b-form-select id="identityType-change-input" @change="changeformFieldView" v-model="identityType">
                  <option selected value="">Select Identity Type</option>
                  <option class="sensorOption" v-for="option in formFieldValue" v-bind:key="option"
                    :value="option.identityType" :disabled="option.disabled">
                    {{ option.identityType ? option.identityType : option.value }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group>
                <b-form-button type="button" class="btn btn-primary" @click="addFormFields(), (showSecondModal = false)">+
                  Add Form Fields
                </b-form-button>
              </b-form-group>
  
              <b-container fluid>
                <b-row v-if="questionnarieFields.length" class="mb-12 update-headings">
                  <b-col>QuestionId</b-col>
                  <b-col class="flex-5">Question</b-col>
                  <b-col>Type</b-col>
                  <b-col>Validation</b-col>
                  <b-col class="close"></b-col>
                  <!-- <b-col >Action</b-col> -->
                </b-row>
  
                <b-row v-for="(list, index) in questionnarieFields" v-bind:key="list" md="6" align="start"
                  class="mb-8 update-fields">
                  <b-col>
                    <b-form-select id="questionId-change-input" v-model="list.questionId">
                      <option class="sensorOption" v-for="option in questionnarieFields" v-bind:key="option"
                        :value="option.questionId" :disabled="option.disabled">
                        {{ option.questionId ? option.questionId : option.value }}
                      </option>
                    </b-form-select>
                  </b-col>
                  <b-col class="flex-5">
                    <b-form-input type="text" :max="500" v-model="list.question"></b-form-input>
                  </b-col>
                  <b-col>
                    <b-form-input type="text" :max="500" v-model="list.type"></b-form-input>
                  </b-col>
                  <b-col>
                    <b-form-input type="text" :max="500" v-model="list.validation"></b-form-input>
                  </b-col>
                  <b-col class="close">
                    <b-button variant="danger" type="button" class="btn btn-danger"
                      @click="clearformFields(index), (showSecondModal = false)">X
                    </b-button>
                  </b-col>
                </b-row>
              </b-container>
            </b-form>
          </b-modal>
          <!--end here 2507 -->
         
         <tv-config-action :tvConfigTitle="tvConfigurationSetUpTitle" ref="tvConfigSettings" :tenantOpt="tenantOpt" />
          <smart-entry-settings-action :tenants="tenants" :tenant="tenantDetails" ref="editQuestionnaireSettings"/>
          <mobile-settings-action :tenant="tenantDetails" :tenants="tenants" ref="mobileSettingsModal"/> 
          <web-settings-action :tenant="tenantDetails" :tenants="tenants" ref="webSettingsActionModal"/>
          <b-modal id="editRuleModal" hide-backdrop centered ok-title="Update" v-bind:title="rulesSettingsTitle"
            @ok="sendUpdateRules" @hidden="editRuleModal" @cancel="editRuleModal">
            <b-form ref="form">
              <b-form-group>
                <label class="checkbox-container">
                  Temperature Alert
                  <input type="checkbox" :value="isTemperatureAlerts" id="isTemperatureAlert" v-model="isTemperatureAlert"
                    :disabled="isTemperatureAlert" />
                  <span class="checkmark"></span>
                </label>
              </b-form-group>
              <b-form-group>
                <label class="checkbox-container">
                  Fall Prevention
                  <input type="checkbox" :value="isFallPreventions" id="isFallPrevention" v-model="isFallPrevention"
                    :disabled="isFallPrevention" />
                  <span class="checkmark"></span>
                </label>
              </b-form-group>
              <b-form-group>
                <label class="checkbox-container">
                  Purpose-full Rounding
                  <input type="checkbox" :value="isPurposefullRoundings" id="isPurposefullRounding"
                    v-model="isPurposefullRounding" :disabled="isPurposefullRounding" />
                  <span class="checkmark"></span>
                </label>
              </b-form-group>
              <b-form-group>
                <label class="checkbox-container">
                  Virtual Monitoring
                  <input type="checkbox" :value="isVirtualMonitor" id="isVirtualMonitor" v-model="isVirtualMonitor"
                    :disabled="isVirtualMonitor" />
                  <span class="checkmark"></span>
                </label>
              </b-form-group>
            </b-form>
          </b-modal>
          
          <b-modal id="samlConnectionSetupModal" hide-backdrop centered :no-close-on-esc="true"
            v-bind:title="samlConnctionSetupTitle" title-class="test" ok-title="Next" ok-disabled
            @hidden="closeConnectionSetupModal" @cancel="closeConnectionSetupModal">
            <b-form ref="form">
              <!-- samlConnectionStep  step ===1 -->
              <b-form-group v-if="samlConnectionStep === 1">
                <label class="custom-form-label">Metadata Mode</label>
                <b-form-select id="mode_type" class="jobType" v-model="samlConnectionObj.mode" :options="samlModeArray"
                  style="width: 100%">
                </b-form-select>
              </b-form-group>
  
              <b-form-group v-if="samlConnectionStep === 2 && samlConnectionObj.mode == 'URL'">
                <label class="custom-form-label">Metadata URL</label>
                <b-form-input id="samlConnectionURL" type="text" v-model="samlConnectionObj.url"></b-form-input>
              </b-form-group>
  
              <b-form-group v-if="samlConnectionStep === 2 && samlConnectionObj.mode == 'File'">
                <label class="custom-form-label">Choose File (metadata.xml)</label>
                <div style="display:flex">
                  <b-form-input disabled id="samlConnectionURL" type="text"
                    v-model="samlConnectionObj.fileName"></b-form-input>
                  <b-button style="float:right; margin-left: 5px;" variant="primary" title="Upload File"
                    @click="uploadFile()">
                    Browse
                  </b-button>
                </div>
                <input type="file" hidden style="display: none" id="filesToUpload" @change="handleFiles" accept=".xml" />
              </b-form-group>
  
  
              <b-form-group v-if="samlConnectionStep === 2 && samlConnectionObj.mode == 'Manual'">
                <label class="custom-form-label">Entity Id</label>
                <b-form-input id="samlConnectionURL" type="text" v-model="samlConnectionObj.entityId"></b-form-input>
              </b-form-group>
              <b-form-group v-if="samlConnectionStep === 2 && samlConnectionObj.mode == 'Manual'">
                <label class="custom-form-label">Name Id</label>
                <b-form-input id="samlConnectionURL" type="text" v-model="samlConnectionObj.nameId"></b-form-input>
              </b-form-group>
              <b-form-group v-if="samlConnectionStep === 2 && samlConnectionObj.mode == 'Manual'">
                <label class="custom-form-label">SSO URL</label>
                <b-form-input id="samlConnectionURL" type="text" v-model="samlConnectionObj.sso"></b-form-input>
              </b-form-group>
              <b-form-group v-if="samlConnectionStep === 2 && samlConnectionObj.mode == 'Manual'">
                <label class="custom-form-label">SLO URL</label>
                <b-form-input id="samlConnectionURL" type="text" v-model="samlConnectionObj.slo"></b-form-input>
              </b-form-group>
              <b-form-group v-if="samlConnectionStep === 2 && samlConnectionObj.mode == 'Manual'">
                <label class="custom-form-label">Choose Certificates (.cer/.crt/.pem)</label>
                <div style="display:flex">
                  <b-form-input disabled id="samlConnectionURL" type="text"
                    v-model="samlConnectionObj.fileName"></b-form-input>
                  <b-button style="float:right; margin-left: 5px;" variant="primary" title="Upload File"
                    @click="uploadManualFile()">
                    Browse
                  </b-button>
                </div>
                <input type="file" hidden style="display: none" id="filesManualToUpload" @change="handleFiles"
                  accept=".cer,.crt,.pem" />
              </b-form-group>
              <b-form-group v-if="samlConnectionStep === 2 && samlConnectionObj.mode == 'Manual'">
                <label class="custom-form-label">Choose encryption (.cer/.crt/.pem)</label>
                <div style="display:flex">
                  <b-form-input disabled id="samlConnectionURL" type="text"
                    v-model="samlConnectionObj.fileNameEncrypted"></b-form-input>
                  <b-button style="float:right; margin-left: 5px;" variant="primary" title="Upload File"
                    @click="uploadEncryptionFile()">
                    Browse
                  </b-button>
                </div>
                <input type="file" hidden style="display: none" id="filesEncryptionToUpload" @change="handleEncryptedFiles"
                  accept=".cer,.crt,.pem" />
              </b-form-group>
  
              <p v-if="samlConnectionStep === 3"> Connection Details</p>
              <b-form-group v-if="samlConnectionStep === 3">
                <label class="custom-form-label">Name</label>
                <b-form-input disabled id="samlConnectionURL" type="text" v-model="samlConnectionObj.name"></b-form-input>
              </b-form-group>
              <b-form-group v-if="samlConnectionStep === 3 && samlConnectionObj.mode == 'URL'">
                <label class="custom-form-label">Metadata URL</label>
                <b-form-input disabled id="samlConnectionURL" type="text"
                  v-model="samlConnectionObj.metaDataURL"></b-form-input>
              </b-form-group>
  
            </b-form>
            <template #modal-footer>
              <b-button variant="secondary" @click="closeConnectionSetupModal()">
                Cancel
              </b-button>
  
              <b-button variant="primary" v-if="samlConnectionStep <= 2" @click="saveSamlConnection()">
                Next
              </b-button>
              <b-button v-if="samlConnectionStep === 3" variant="primary" @click="doneSamlConnection()">
                Done
              </b-button>
  
  
            </template>
  
          </b-modal>
  
          <p v-if="next && next.length > 0">
            <button id="btnLoadMore" class="btn btn-primary btn-margin" @click.prevent="fetchData">
              Load More
            </button>
          </p>
        </div>
        <div v-if="viewSubmissionList == true" class="pageDataWrapper pageActualDataWrapper">
          <div class="row m-0 align-items-right">
            <button id="btnCLoseSubmit" class="btn btn-primary btn-margin float-right" @click="closeViewSubmission">
              Close
            </button>
          </div>
          <div class="contentHeader row m-0 align-items-center">
            <div class="col">Status</div>
            <div class="col">Date</div>
            <div class="col">Group Name</div>
            <div class="col">When</div>
            <div class="col">Who</div>
            <div class="col">To</div>
            <div class="col">View</div>
          </div>
          <div class="contentDataWrap">
            <div class="contentDataWrapper contentActualDataWrapper row m-0" v-for="submission in viewSubmissionListData"
              v-bind:key="submission">
              <div class="contentData row align-items-center col-12 p-0">
                <div class="col">{{ submission.status }}</div>
                <div class="col">{{ submission.date | formatDate }}</div>
                <div class="col">{{ submission.groupName }}</div>
                <div class="col">{{ submission.createdOn | formatDate }}</div>
                <div class="col">{{ submission.createdBy }}</div>
                <div class="col">
                  {{ submission.sentTo ? submission.sentTo.join(",") : "" }}
                </div>
                <div class="col">
                  <button v-if="submission.status == 'IN-PROGRESS' ||
                    submission.status == 'RECEIVED' ||
                    submission.status == 'IN-REVIEW' ||
                    submission.status == 'IMPORTED'
                    " id="btnViewSubmit" class="btn btn-primary btn-margin float-center"
                    @click="viewOnboardingForm(submission)">
                    View
                  </button>
                  &nbsp;
                  <button v-if="submission.status == 'IN-REVIEW'" id="btnViewSubmit"
                    class="btn btn-primary btn-margin float-center">
                    Import
                  </button>
                </div>
                <!-- <div class="col">
                 
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedTenant">
        <h4>{{ selectedTenant.fullName }}</h4>
        <br />
        <!-- <div style="width:100%;text-align:right">
          <button class="btn btn-info" style="margin-left:5px;border-radius:20px"  @click.prevent="closeCharts">Close</button> 
          <button class="btn btn-info" v-if="selectedTenant.isPrivacyEnabled" style="margin-left:5px;margin-right=10px;border-radius:20px" @click.prevent="disablePrivacy()">Disable Privacy Mode</button> 
          <button class="btn btn-info" v-if="!selectedTenant.isPrivacyEnabled" style="margin-left:5px;margin-right=10px;border-radius:20px" @click="showModal = true">Enable Privacy Mode</button>
          <button class="btn btn-info" v-if="currentTenantWeekReport != null && currentTenantWeekReport.length > 0" style="margin-left:5px;border-radius:20px" @click.prevent="exportReport()">Export Report Data</button><br/>       
        </div>-->
        <div v-if="$auth.isAuthenticated" class="cards-container">
          <div class="row m-0 dashboardBlocksWrapper">
            <div class="col dashboardBlock">
              <div class="dashboardIcon">
                <img src="../../assets/images/scansBlockIcon.svg" width="22" />
              </div>
              <div class="dashboardNumber">
                {{ tenantStats.total }}
                <span>Total Scan</span>
              </div>
            </div>
            <div class="col dashboardBlock">
              <div class="dashboardIcon">
                <img src="../../assets/images/scansBlockIcon.svg" width="22" />
              </div>
              <div class="dashboardNumber">
                {{ tenantStats.abnormal }}
                <span>Abnormal Scans</span>
              </div>
            </div>
            <div class="col dashboardBlock">
              <div class="dashboardIcon">
                <img src="../../assets/images/scansBlockIcon.svg" width="22" />
              </div>
              <div class="dashboardNumber">
                {{ tenantStats.low }}
                <span>Low Scans</span>
              </div>
            </div>
            <div class="col dashboardBlock">
              <div class="dashboardIcon">
                <img src="../../assets/images/scansBlockIcon.svg" width />
              </div>
              <div class="dashboardNumber">
                {{ tenantStats.normal }}
                <span>Normal Scans</span>
              </div>
            </div>
          </div>
          <h6>
            <div style="width: 100%; text-align: right">
              <button class="btn btn-info" style="margin-left: 5px; border-radius: 20px" @click.prevent="closeCharts">
                Close
              </button>
              <button class="btn btn-info" v-if="selectedTenant.isPrivacyEnabled"
                style="margin-left:5px;margin-right=10px;border-radius:20px" @click.prevent="disablePrivacy()">
                Disable Privacy Mode
              </button>
              <button class="btn btn-info" v-if="!selectedTenant.isPrivacyEnabled"
                style="margin-left:5px;margin-right=10px;border-radius:20px" @click="showModal = true">
                Enable Privacy Mode
              </button>
              <!-- <button class="btn btn-info" v-if="currentTenantWeekReport != null && currentTenantWeekReport.length > 0" style="margin-left:5px;border-radius:20px" @click.prevent="exportReport()">Export Report Data</button><br/>         -->
              <button class="btn btn-info" style="margin-left: 5px; border-radius: 20px" @click.prevent="exportReport()">
                Export Report Data
              </button>
              <br />
            </div>
          </h6>
        </div>
        <div class="container p-3 my-3 border"></div>
        ​
        <div style="
                                                position: absolute;
                                                width: 80%;
                                                padding: 0px !important;
                                                margin: 0px !important;
                                                min-height: 0px;
                                                left: 20px;
                                                top: 270px;
                                              " id="mainChart">
          <div class="chartjs-size-monitor">
            <div class="chartjs-size-monitor-expand">
              <div class></div>
            </div>
            <div class="chartjs-size-monitor-shrink">
              <div class></div>
            </div>
          </div>
          <canvas id="canvas" style="display: block" class="chartjs-render-monitor"></canvas>
        </div>
        <div style="
                                                width: 100%;
                                                padding: 0px !important;
                                                margin: 0px !important;
                                                min-height: 700px;
                                              " id="subChart">
          <div class="chartjs-size-monitor">
            <div class="chartjs-size-monitor-expand">
              <div class></div>
            </div>
            <div class="chartjs-size-monitor-shrink">
              <div class></div>
            </div>
          </div>
          <canvas id="locCanvas" style="display: block;rectangle;" class="chartjs-render-monitor-subchart"></canvas>
          <!--<a class="closeSubChart" onclick="document.getElementById('subChart').style.display = 'none';document.getElementById('mainChart').style.display='';">Back to All Facilities</a>-->
        </div>
      </div>
  
      <!-- Modal Content  -->
      <div v-if="showModal">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title"></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" @click="showModal = false">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <p class="m-0">Are you sure you want to disable privacy ?</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="showModal = false">
                      Cancel
                    </button>
                    <button type="button" class="btn btn-primary" @click="(showSecondModal = true), (showModal = false)">
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- modal body tenant -->
      <!-- class="modal-title text-white lead" -->
  
      <b-modal v-model="showModal2" size="sm" dialog-class="custom-modal-dialog" hide-footer hide-backdrop @hidden="reset"
        class="custom-modal-dialog">
        <template v-slot:modal-title>
          <h4>Tenant - {{ getTenant.name }} - Release Notes - {{ selectedVersion }}</h4>
        </template>
        <div class="modal-body" @click.self="closeModal">
          <div class="d-flex justify-content-end mt-3 ml-3">
            <button v-if="!showUpcoming" type="button" class="btn btn-primary mb-4" data-bs-target="#exampleModal"
              @click="upcomingVersion">
              UPCOMING UPDATES
            </button>
          </div>
          <div class="scrollable-container mr-2 ml-2">
            <div v-for="(update, index) in upcomingUpdates.concat(verRelease)" :key="update.id" class="m-3">
              <div v-if="upcomingUpdates.includes(update)">
                <div>
                  {{ update.date }} - {{ update.target }} - <strong>Upcoming updates</strong>
                </div>
                <div class="box-color p-2">
                  <div class="mt-2">
                    <span class="badge badge-primary text-white">{{ update.type }}</span>
                    <div>
                      <p>{{ update.description }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="showUpcoming && index === upcomingUpdates.length">
                  <div v-if="upcomingUpdates.length === 0" class="pad-0">
                    <span style="margin: 10;">&nbsp;There is no upcoming release available for this version</span>
                  </div>
                  <div class="separator" style="background-color: #f59572;height: 8px; padding: 0px">
                    <p class="text-white"></p>
                  </div>
                  <div class="pad-0" style="padding-bottom: 10px">
                    <span class="text-white" style="background-color: #f59572; padding: 0px">&nbsp;CURRENT&nbsp;</span>
                  </div>
                </div>
                <div>
                  {{ update.date }}
                </div>
                <div class="box-color p-2">
                  <div class="mt-2">
                    <span class="badge badge-primary text-white">{{ update.type }}</span>
                    <div>
                      <p>{{ update.description }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
  
  
  
      <div v-if="showViewOnboardDialog">
        <b-modal size="xl" v-model="showViewOnboardDialog" id="SendOnboardingModal" hide-backdrop centered
          v-bind:title="viewOnboardingTitle" @hidden="showViewOnboardDialog = false"
          @cancel="showViewOnboardDialog = false">
          <div>
            <iframe v-if="showViewOnboardDialog" width="100%" height="600" @click="showViewOnboardDialog = false"
              frameborder="0" :src="onboardingViewModelURL"></iframe>
          </div>
        </b-modal>
      </div>
  
      <div v-if="showSecondModal">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title"></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" @click="showSecondModal = false">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <p>Hey User! You 100% sure you want to enable privacy?</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="showSecondModal = false">
                      Cancel
                    </button>
                    <button type="button" class="btn btn-primary" @click="clearTenant(), (showSecondModal = false)">
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
  
      <!-- modal conten ends here -->
  
      <!-- Modal Popup Start Here  --> 
      <b-modal v-model="showSendOnboardCreationDialog" id="SendOnboardingModal" hide-backdrop centered
        v-bind:title="viewOnboardingTitle" ok-title="Send" @ok="sendOnboarding"
        @hidden="showSendOnboardCreationDialog = false" @cancel="showSendOnboardCreationDialog = false">
        <b-form ref="form">
          <b-form-group label="Email">
            <vue-tags-input placeholder="Add Email" v-model="tag" :tags="tags"
              @tags-changed="(newTags) => (tags = newTags)" />
          </b-form-group>
          <b-form-group label="Group Name">
            <b-form-input id="tbxQuestion1" value v-model="SendOnboardingDocument.nameGroup"></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-button type="button" class="btn btn-primary" @click="addBudget(), (showSecondModal = false)">+ Add
              Sensor Budget
            </b-form-button>
          </b-form-group>
  
          <b-container fluid>
            <b-row v-if="addBudgetList.length" class="mb-12">
              <b-col>sensor Type</b-col>
              <b-col>sensor Count</b-col>
              <b-col></b-col>
              <!-- <b-col >Action</b-col> -->
            </b-row>
            <b-row v-for="(list, index) in addBudgetList" :key="list" md="6" align="start" class="mb-12">
              <b-col cols="4">
                <b-form-select id="SensorType-change-input" v-model="list.sensorType">
                  <option class="sensorOption" v-for="option in sensorValue" v-bind:key="option" :value="option.label"
                    :disabled="option.disabled">
                    {{ option.label ? option.label : option.value }}
                  </option>
                </b-form-select>
              </b-col>
              <b-col cols="4">
                <b-form-input type="number" :max="500" v-model="list.sensorCount"></b-form-input>
              </b-col>
              <b-col cols="4">
                <b-button variant="danger" type="button" class="btn btn-danger"
                  @click="clearSensorBudget(index), (showSecondModal = false)">X
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-form>
      </b-modal>
      <!-- Modal Popup End here  -->
      <b-modal id="tenantModal" hide-backdrop centered title="Create Tenant" ok-title="Create"
        :ok-disabled="disableCreateTenant()" @ok="createTenant" @hidden="tenantModal" @cancel="tenantModal">
        <b-form ref="form">
          <b-form-group label="Tenant Name">
            <b-form-input id="tbTenantName" v-model="tenantInfo.tenantName"></b-form-input>
          </b-form-group>
          <b-form-group label="Tenant Id">
            <b-form-input id="tbTenantId" v-model="tenantInfo.tenantId"></b-form-input>
          </b-form-group>
          <!-- <b-form-group>
            <label class="checkbox-container">
              Is Privacy Enabled
              <input type="checkbox" :value="tenantInfo.isPrivacy" id="isPrivacy" v-model="tenantInfo.isPrivacy" />
              <span class="checkmark"></span>
            </label>
          </b-form-group>
          <b-form-group>
            <label class="checkbox-container">
              Use care.ai Authentication
              <input type="checkbox" :value="tenantInfo.careaiAuth" id="careaiAuth" v-model="tenantInfo.careaiAuth" />
              <span class="checkmark"></span>
            </label>
          </b-form-group>
          <b-form-group v-if="tenantInfo.careaiAuth == false" label="Auth0 Connection Name">
            <b-form-input id="tbAuthName" v-model="tenantInfo.authConnectionName"></b-form-input>
          </b-form-group>
          <b-form-group label="Activity Frequency">
            <select class="selectDD" v-model="tenantInfo.purgeActivity">
              <option v-for="optionObj in mappingList" v-bind:key="optionObj.value" :value="optionObj.value">
                {{ optionObj.text ? optionObj.text : optionObj.value }}
              </option>
            </select>
          </b-form-group> -->
        </b-form>
      </b-modal>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import VueToast from "vue-toast-notification";
  import VueSimpleAlert from "vue-simple-alert";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import VoerroTagsInput from "@voerro/vue-tagsinput";
  import VueTagsInput from "@johmun/vue-tags-input";
  import TvConfigAction from "./TvConfigAction.vue";
  import MobileSettingsAction from './MobileSettingsAction.vue';
  import SmartEntrySettingsAction from "./SmartEntrySettingsAction.vue";
  import WebSettingsAction from "./WebSettingsAction.vue";
  Vue.use(VueSimpleAlert);
  import "vue-toast-notification/dist/theme-sugar.css";
  Vue.use(VueToast);
  Vue.use(Loading);
  import Grid from "../../components/Grid.vue";
  Vue.component("tags-input", VoerroTagsInput);
  export default {
    name: "Tenants",
    data() {
      return {
        tenants: [],
        verNum: "",
        verRelease: '',
        selectedVerison: '',
        version: '',
        getTenant: '',
        countlimit: null,
        showModal: false,
        showModal2: false,
        showModal3: false,
        showUpcoming: false,
        upcomingUpdates: [],
        showSecondModal: false,
        filterString: "",
        isTemperatureAlerts: false,
        isFallPreventions: false,
        isPurposefullRoundings: false,
        editRuleModal: false,
        sensorTypeState: null,
        counts: 0,
        releaseVersions: [],
        sensorTypeSelect: "",
        sensorList: [],
        ruleList: [],
        sensorValue: [],
        formFieldValue: [],
        tenantRulesValue: [],
        show: false,
        next: "",
        addBudgetList: [],
        questionnarieFields: [],
        editTimer: "",
        loading: true,
        items: [],
        errorMessage: "",
        tenantAction: "",
        lastTenant: "",
        lastSelectedTenant: "",
        selectedTenant: null,
        currentTenantWeekReport: [],
        startOfWeekForReport: moment().startOf("week"),
        tenantLocations: null,
        reportDateRange: [],
        tenantStats: {total: 0, low: 0, abnormal: 0, normal: 0},
        SendOnboardingDocument: {
          toEmail: "",
          nameGroup: "",
          facilityName: "",
          timeZone: "",
        },
        identityType: "",
        tenantInfo: {
          tenantName: "",
          tenantId: "",
          createPraking: false,
          isPrivacy: false,
          careaiAuth: true,
          authConnectionName: "",
          purgeActivity: "",
        },
        rulesSettingsTitle: "",
        tag: "",
        tags: [],
        //fields added 2507 ticket 
        isTemperatureAlert: false,
        isFallPrevention: false,
        isPurposefullRounding: false,
        isVirtualMonitor: false,
        hasQuestionnarieTemplete: false,
        hasQuestionnarieTempleteExists: false,
        showSendOnboardCreationDialog: false,
        showformFieldCreationDialog: false,
        viewSubmissionList: false,
        viewSubmissionListData: [],
        showViewOnboardDialog: false,
        onboardingViewModelURL: "",
        viewOnboardingTitle: "",
        nextTenantPointer: null,
        covidFormFieldsTitle: "",
        checkedRules: [],
        disabledRules: [],
        dateRange: "",
        okButtonDisabled: false,
        mappingList: [
          {text: "Never", value: "-1"},
          {text: "Every 30 mins", value: "30"},
          {text: "Hourly", value: "60"},
          {text: "Daily", value: "1440"},
          {text: "Weekly", value: "10080"},
          {text: "Monthly", value: "43200"},
        ],
        virtualMonitorValues: [
          {
            name: "Conference Created",
            triggerCondition:
                "event.event.code==='VIRTUALVISIT_CALL_DEVICE_CONF_CREATED'",
          },
          {
            name: "Calling Phone",
            triggerCondition: "event.event.code==='VIRTUALVISIT_CALL_PHONE'",
          },
          {
            name: "Call Initiated",
            triggerCondition: "event.event.code==='VIRTUALVISIT_CALL_DEVICE'",
          },
          {
            name: "Incoming Call",
            triggerCondition: "event.event.code==='VIRTUALVISIT_CALL_NURSE'",
          },
          {
            name: "Conference Joined",
            triggerCondition: "event.event.code==='VIRTUALVISIT_CALL_JOINED'",
          },
          {
            name: "Call Initiated To Nurse Device",
            triggerCondition:
                "event.event.code==='VIRTUALVISIT_CALL_NURSE_DEVICE'",
          },
          {
            name: "End Audio",
            triggerCondition: "event.event.code==='VIRTUALVISIT_END_AUDIO'",
          },
          {
            name: "Play Audio",
            triggerCondition: "event.event.code==='VIRTUALVISIT_PLAY_AUDIO'",
          },
        ],
        samlConnctionSetupTitle: "",
        samlModeArray: ['URL', 'File', 'Manual'],
        samlConnectionObj: {
          mode: "",
          fileName: "",
          fileNameEncrypted: ""
        },
        samlConnectionStep: 1,
        tenantOpt:"",
        tvConfigurationSetUpTitle:"",
        tenantDetails:[]
      };
  
  
    },
  
    components: {
      Grid,
      VueTagsInput,
      TvConfigAction,
      MobileSettingsAction,
      WebSettingsAction,
      SmartEntrySettingsAction
    },
   
    async created() {
      // fetch the data when the view is created and the data is
      // already being observed
      let externalScript = document.createElement("script");
      externalScript.setAttribute(
          "src",
          "https://www.chartjs.org/dist/2.9.3/Chart.min.js"
      );
      document.head.appendChild(externalScript);
      this.tenants = [];
      await this.getReleaseVersions();
      this.fetchData();
  
    },
    methods: {
      onDateChange() {
        this.dateValue = this.value.format("YYYY-MM-DD");
      },
      onDateRangeChange() {
        this.fromDate = this.dateRange[0].format("YYYY-MM-DD") + "T00:00:00.000Z"
        this.toDate = this.dateRange[1].format("YYYY-MM-DD") + "T00:00:00.000Z"
      },
      getVersion(tenant) {
        let releaseVersion = this.releaseVersions.find(e => e.tenants.includes(tenant.name));
        if (!releaseVersion) {
          releaseVersion = this.releaseVersions.find(e => e.defaultRelease === true)
        }
        this.getTenant = tenant;
        this.selecVersion = releaseVersion.version.replace('v', '');
        this.selectedVersion = releaseVersion.version
        this.selectVersion()
      },
      reset() {
        this.showModal2 = false;
        this.showModal3 = false;
        this.showUpcoming = false;
        this.upcomingUpdates = [];
        this.verRelease = [];
        this.getTenant = {};
        this.selectedVersion = '';
      },
      async tenantModal() {
        this.$bvModal.hide("tenantModal");
      },
      async showTenantModal() {
        this.tenantInfo = {
          tenantName: "",
          tenantId: "",
          createPraking: false,
          isPrivacy: false,
          careaiAuth: true,
          authConnectionName: "",
          purgeActivity: "",
        };
        this.$bvModal.show("tenantModal");
      },
      async openWebSettings(tenant){
        this.tenantDetails=tenant;
        this.$refs.webSettingsActionModal.$bvModal.show("webSettingsModal")
      },
      async openMobileSettings(tenant) {
        this.tenantDetails=tenant;
        this.tenants;
        this.$refs.mobileSettingsModal.$bvModal.show("editMobileModal");
      },
      async openQuestionnaireSettings(tenant){
        this.tenantDetails=tenant;
        this.tenants;
        this.$refs.editQuestionnaireSettings.$bvModal.show("editQuestionnaireModal");
      },
      
      async tvConfigurationSetup(tenant) {
       this.tvConfigurationSetUpTitle = tenant.fullName + ": TV Configuration Settings";
       this.tenantOpt = tenant.name;
       this.$refs.tvConfigSettings.$bvModal.show('tvConfigurationSettingsModal');
  
      },
      async samlConnectionSetup(tenant) {
        this.tenants;
        this.lastTenant = tenant.name;
        this.samlConnectionStep = 1;
        this.samlConnctionSetupTitle = tenant.fullName + ": SAML Connection";
        this.samlConnectionObj["mode"] = this.samlModeArray[0]
        this.$bvModal.show("samlConnectionSetupModal");
      },
  
      async saveSamlConnection() {
        this.samlConnectionStep = this.samlConnectionStep + 1;
        if (this.samlConnectionStep == 2)
          this.samlConnctionSetupTitle = this.samlConnectionObj.mode === "Manual" ? this.samlConnctionSetupTitle + " - " + "Manual/Confirm" : this.samlConnctionSetupTitle + " - " + this.samlConnectionObj.mode
        this.samlConnectionObj["metaDataURL"] = this.samlConnectionObj.url ? this.samlConnectionObj.url : "";
        this.samlConnectionObj["name"] = this.lastTenant + "-saml-" + moment(new Date()).format('MMDDYYYYHHmmss');
      },
      async doneSamlConnection() {
       
        this.$bvModal.hide("samlConnectionSetupModal");
        Vue.$toast.open({
          message: "This feature is comming soon ",
          type: "success",
        });
        this.samlConnectionObj = {
          mode: "",
          fileName: "",
          fileNameEncrypted: ""
        };
      },
      async updateTime() {
        return moment(new Date()).format('MM/DD/YYYY hh:mm:ss a').replace(',', '');
      },
      closeConnectionSetupModal() {
        this.$bvModal.hide("samlConnectionSetupModal");
        this.samlConnectionObj = {
          mode: "",
          fileName: "",
          fileNameEncrypted: ""
        };//clearing the selection/added details after closing the model
      },
      async uploadFile() {
        document.getElementById("filesToUpload").click();
      },
      async uploadManualFile() {
        document.getElementById("filesManualToUpload").click();
      },
      async uploadEncryptionFile() {
        document.getElementById("filesEncryptionToUpload").click();
      },
      handleFiles(event) {
        //alert(this.importLoadingMessage);
        //Vue.$toast.open("Loading File");
        // Check for the various File API support.
        if (window.FileReader) {
          // FileReader are supported.
          //getAsText(files[0]);
          var fileToRead = event.target.files[0];
          this.samlConnectionObj.fileName = fileToRead.name
          var reader = new FileReader();
          // Handle errors load
          reader.onerror = (evt) => {
            if (evt.target.error.name == "NotReadableError") {
              // this.importLoadingMessage = "ERROR reading file";
              Vue.$toast.open({message: "ERROR reading file", type: "error"});
              this.importedDeviceIds = null;
  
              // alert("Cannot read file !");
              Vue.$toast.open({message: "Cannot read file !", type: "error"});
            }
          };
          reader.onload = (event) => {
            var csv = event.target.result;
  
          };
          // Read file into memory as UTF-8
          reader.readAsText(fileToRead);
        } else {
          // alert("FileReader are not supported in this browser.");
          Vue.$toast.open({
            message: "FileReader are not supported in this browser",
            type: "error",
          });
        }
      },
      handleEncryptedFiles(event) {
        //alert(this.importLoadingMessage);
        //Vue.$toast.open("Loading File");
        // Check for the various File API support.
        if (window.FileReader) {
          // FileReader are supported.
          //getAsText(files[0]);
          var fileToRead = event.target.files[0];
          this.samlConnectionObj.fileNameEncrypted = fileToRead.name
          var reader = new FileReader();
          // Handle errors load
          reader.onerror = (evt) => {
            if (evt.target.error.name == "NotReadableError") {
              // this.importLoadingMessage = "ERROR reading file";
              Vue.$toast.open({message: "ERROR reading file", type: "error"});
              this.importedDeviceIds = null;
  
              // alert("Cannot read file !");
              Vue.$toast.open({message: "Cannot read file !", type: "error"});
            }
          };
          reader.onload = (event) => {
            var csv = event.target.result;
  
          };
          // Read file into memory as UTF-8
          reader.readAsText(fileToRead);
        } else {
          // alert("FileReader are not supported in this browser.");
          Vue.$toast.open({
            message: "FileReader are not supported in this browser",
            type: "error",
          });
        }
      },
      async enableRuleSettings(tenant) {
        let loader = Vue.$loading.show({
          // Optional parameters
          color: "skyblue",
          opacity: 0.1,
          loader: "dots",
        });
  
        this.rulesSettingsTitle = "Activate Tenant Features - " + tenant.name;
        this.lastTenant = tenant.name;
        await this.showTenantRuleResponse(this.lastTenant);
        this.getRuleData();
        loader.hide();
        this.$bvModal.show("editRuleModal");
      },
      getRuleData() {
        this.ruleList = [];
        this.virtualMonitorValues.every((e) => {
          if (
              !this.tenantRulesValue.find(
                  (x) =>
                      x.name === e.name &&
                      x.triggerCondition.includes(e.triggerCondition)
              )
          ) {
            this.isVirtualMonitor = false;
            return false;
          }
          this.isVirtualMonitor = true;
          return true;
        });
        var temperatureAlert = this.tenantRulesValue.find(
            (x) =>
                x.name === "Temperature Alert" &&
                x.triggerCondition.includes("ACTIVITIES_UNKNOWN_SEEN")
        );
        var fallPrevention = this.tenantRulesValue.find(
            (x) =>
                x.name === "Fall Prevention" &&
                x.triggerCondition.includes("ACTIVITIES_PERSON_GETTING_UP")
        );
        var purposeFullRounding = this.tenantRulesValue.find(
            (x) =>
                x.name === "Purposeful Rounding" &&
                x.triggerCondition.includes("N_ACTIVITIES_PROVIDER_ROUNDING_ALERT")
        );
        this.isTemperatureAlert =
            temperatureAlert && temperatureAlert.name ? true : false;
        this.isFallPrevention =
            fallPrevention && fallPrevention.name ? true : false;
        this.isPurposefullRounding =
            purposeFullRounding && purposeFullRounding.name ? true : false;
        this.checkedRules = [];
        this.disabledRules = [];
      },
      async checkForm() {
        if (this.countlimit > 500) {
          this.errorMessage = "Count value should be lesser then 500";
        }
      },
  
      async selectTenant(t) {
        this.tenantLocations = null;
        this.startOfWeekForReport = moment().startOf("week");
        this.selectedTenant = this.tenants.find((x) => x.name === t);
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        Vue.$toast.open({
          message: "Fetching Reports for " + t,
          type: "info",
          duration: 3000,
          position: "bottom",
        });
        //showGlobalOverlay('');
        let loader = Vue.$loading.show({
          // Optional parameters
          color: "skyblue",
          opacity: 0.1,
          loader: "dots",
        });
        setTimeout(() => {
          loader.hide();
        }, 7000);
        await this.getLocations(t, id_token);
        await this.loadTenantReports(t, id_token);
      },
      closeCharts() {
        if (document.getElementById("mainChart").style.display == "none") {
          document.getElementById("subChart").style.display = "none";
          document.getElementById("mainChart").style.display = "";
        } else {
          this.clearTenant();
        }
      },
      async showViewSubmission(tenant) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url = config.TENET_SERVICE + `/tenants/${tenant.name}/onboarding`;
        var sendOnBoadingRequest = new Request(url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          this.viewSubmissionList = true;
          var sendOnBoardingResponse = await fetch(sendOnBoadingRequest);
          if (sendOnBoardingResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendOnBoardingResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendOnBoardingResponse.status == 503) {
            return this.showViewSubmission(tenant);
          }
          if (sendOnBoardingResponse.status != 200) {
            this.commandError = "Failed to send email for onboarding";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var sendOnBoardingBody = await sendOnBoardingResponse.json();
            this.viewSubmissionListData = sendOnBoardingBody.onboarding;
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      async getReleaseVersions() {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url = config.TENET_SERVICE + `/release-versions`;
        var sendOnBoadingRequest = new Request(url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var sendOnBoardingResponse = await fetch(sendOnBoadingRequest);
          if (sendOnBoardingResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendOnBoardingResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendOnBoardingResponse.status == 503) {
            return this.getReleaseVersions();
          }
          if (sendOnBoardingResponse.status != 200) {
            this.commandError = "Failed to send email for onboarding";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var sendOnBoardingBody = await sendOnBoardingResponse.json();
            this.releaseVersions = sendOnBoardingBody.items;
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      async showOnboardRespose(tenant) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url =
            config.ONBOARDING_FORM +
            `/forms/onboarding/?tenant=${tenant}&access_token=${id_token}`;
        var fetchFormRequest = new Request(url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            "Content-Type": "application/json",
          },
        });
        try {
          this.viewSubmissionList = true;
          var fetchFormResponse = await fetch(fetchFormRequest);
          if (fetchFormResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (fetchFormResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (fetchFormResponse.status == 503) {
            return this.showOnboardRespose(tenant);
          }
          if (fetchFormResponse.status != 200) {
            this.commandError = "Failed to fetch on board response";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var getFormResposeData = await fetchFormResponse.json();
  
            var data = (this.sensorList = getFormResposeData.components);
  
            let componentList = data.find((sl) => sl.title === "Sensors");
            let list = componentList.components.find(
                (cl) => cl.label === "Sensors"
            );
            let sensorTypeList = list.components.find(
                (st) => st.label === "Sensor Type"
            );
            this.sensorValue = sensorTypeList.data.values;
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      closeViewSubmission() {
        this.viewSubmissionList = false;
      },
      openModal(tenant) {
        this.addBudgetList = [];
        this.viewOnboardingTitle = "Send Onboarding - " + tenant.fullName;
        this.showSendOnboardCreationDialog = true;
        this.lastSelectedTenant = this.getName(tenant);
  
        this.showOnboardRespose(this.lastSelectedTenant);
        this.SendOnboardingDocument = {
          nameGroup: "",
          toEmail: "",
          facilityName: "",
          timeZone: "",
        };
        this.tags = [];
        this.tag = "";
        //  groupName: this.SendOnboardingDocument.nameGroup,
        //     email: this.SendOnboardingDocument.toEmail,
        //     facilityName: this.SendOnboardingDocument.facilityName,
        //     timeZone: this.SendOnboardingDocument.timeZone
        this.$bvModal.show("SendOnboardingModal");
      },
      resetModal() {
        this.$bvModal.hide("SendOnboardingModal");
      },
      updateForm(tenant) {
        this.covidFormFieldsTitle = "Covid-19 Form Fields - " + tenant.fullName;
        this.showformFieldCreationDialog = true;
        this.showFormFieldsRespose(this.lastSelectedTenant);
        this.lastSelectedTenant = this.getName(tenant);
  
        //this.identityType : ""
  
        this.$bvModal.show("updateFormFields");
      },
      async viewOnboardingForm(submission) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
  
        var tenant = submission.tenant;
        var id = submission.id;
        this.viewOnboardingTitle =
            "View Onboarding - " + submission.tenant + " - " + submission.groupName;
        this.onboardingViewModelURL =
            config.ONBOARDING_FORM + "/" + tenant + "/" + id + "#token=" + id_token;
  
        this.showViewOnboardDialog = true;
  
        if (submission.status != "IN-REVIEW") {
          submission.status = "IN-REVIEW";
  
          this.updateStatus(id);
        }
      },
      async changeformFieldView() {
        let res = this.formFieldValue.filter(
            (x) => x.identityType == this.identityType
        );
        if (res && res.length > 0) {
          this.questionnarieFields = res[0].questions;
        }
      },
      async updateStatus(id) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        //  var url =
        //     config.ONBOARDING_FORM + "/formResponse/" + id;
        var url = config.ONBOARDING_FORM + "/formResponse/" + id;
        var onboard_status_update = new Request(url, {
          method: "PATCH",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          body: JSON.stringify({
            status: "IN-REVIEW",
          }),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var onboardStatusUpdate = await fetch(onboard_status_update);
          if (onboardStatusUpdate.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (onboardStatusUpdate.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (onboardStatusUpdate.status == 503) {
            return this.updateStatus(id);
          }
          if (onboardStatusUpdate.status != 200) {
            (this.errorMessage = "Error occurred to "),
                command.command,
                " :",
                onboardStatusUpdate.status;
  
            this.commandError = "Failed to update Role";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var onboardStatusBody = await onboardStatusUpdate.json();
            this.commandError = "";
            Vue.$toast.open({
              message: "Successfully Updated status",
              type: "success",
            });
  
            // this.fetchRoles();
          }
        } catch (tex) {
          this.commandError = "Failed! due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      disableCreateTenant() {
       return true //making create tenant temporarily disabled
      },
      async createTenant() {
        // this.$bvModal.show("tenantModal");
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        // var url = config.TENET_SERVICE + `/tenants/`;
        // var createTenantRequest = new Request(url, {
        //   method: "POST",
        //   mode: "cors",
        //   withCredentials: true,
        //   credentials: "include",
        //   cache: "default",
        //   body: JSON.stringify({
        //     tenantName: this.tenantInfo.tenantName,
        //     properties: {
        //       fullName: this.tenantInfo.tenantName,
        //       url: "https://" + this.tenantInfo.tenantId + ".care.ai",
        //       authConnection: this.tenantInfo.authConnectionName,
        //       isPrivacyEnabled: this.tenantInfo.isPrivacy,
        //       createAuthStore: this.tenantInfo.careaiAuth,
        //       purgeActivityFrequency: this.tenantInfo.purgeActivity,
        //       createParkingLotLocations: this.tenantInfo.createPraking,
        //     },
        //   }),
        //   headers: {
        //     Authorization: "Bearer " + id_token,
        //     "Content-Type": "application/json",
        //   },
        // });
        // try {
        //   var createTenantResponse = await fetch(createTenantRequest);
        //   if (createTenantResponse.status === 403) {
        //     this.errorMessage =
        //       "Uh oh... You don't have the permission required to access this resource";
        //     Vue.$toast.open({ message: this.errorMessage, type: "error" });
        //     return;
        //   }
        //   if (createTenantResponse.status == 401) {
        //     this.errorMessage =
        //       "Your session has expired please login again to continue";
        //     Vue.$toast.open({ message: this.errorMessage, type: "error" });
        //     return;
        //   }
        //   if (createTenantResponse.status == 503) {
        //     return this.createTenant();
        //   }
        //   if (createTenantResponse.status != 200) {
        //     this.commandError = "Failed to create new Tenant";
        //     Vue.$toast.open({ message: this.commandError, type: "error" });
        //   } else {
        //     var createTenantBody = await createTenantResponse.json();
        //     this.tenants.push(createTenantBody);
        //     this.commandError = "";
        //     this.$bvModal.show("hide");
        //     Vue.$toast.open({
        //       message: "Successfully created tenant.",
        //       type: "success",
        //     });
        //   }
        // } catch (tex) {
        //   this.commandError =
        //     "Failed to " + command.command + " due to an error.";
        //   Vue.$toast.open({ message: this.commandError, type: "error" });
        // }
  
        this.$bvModal.show("hide");
        Vue.$toast.open({
          message: "This feature is comming soon",
          type: "success",
        });
  
      },
      async showTenantRuleResponse(tenant) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url = config.TENET_SERVICE + `/tenants/${tenant}/rules`;
        var fetchTenantRuleRequest = new Request(url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var fetchTenantRuleResponse = await fetch(fetchTenantRuleRequest);
          if (fetchTenantRuleResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (fetchTenantRuleResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (fetchTenantRuleResponse.status == 503) {
            return this.showTenantRuleResponse(tenant);
          }
          if (fetchTenantRuleResponse.status != 200) {
            this.commandError = "Failed to fetch Rules";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var ruleResponse = await fetchTenantRuleResponse.json();
            this.tenantRulesValue = ruleResponse;
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
          return;
        }
      },
      async selectVersion() {
        let loader = Vue.$loading.show({
          color: "skyblue",
          opacity: 0.1,
          loader: "dots",
        });
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url =
            config.TENET_SERVICE + `/tenants/${this.getTenant.name}/release-notes?limit=100&offset=0&appVersionNumber=${this.selectedVersion}`;
        var release_Versinon = new Request(url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          const releaseVerison = await fetch(release_Versinon)
          const verisonRelease = await releaseVerison.json()
          this.verRelease = verisonRelease.items
          this.showModal2 = true;
          loader.hide()
        } catch (error) {
          loader.hide()
          console.log(error)
        }
      },
      async upcomingVersion() {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
  
        var url =
            config.TENET_SERVICE + `/tenants/${this.getTenant.name}/release-notes?limit=100&offset=0&appVersionNumber=${this.selecVersion}&isUpcommingVersion=true`;
        var upcoming_Versinon = new Request(url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          const futureVerison = await fetch(upcoming_Versinon)
          if (futureVerison.status === 503) {
            return this.upcomingVersion();
          }
          const upVersion = await futureVerison.json()
          this.upcomingUpdates = upVersion.items
          this.showModal3 = true;
          this.showUpcoming = true
        } catch (error) {
          console.log(error)
        }
      },
      async sendFormFields() {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url =
            config.COVID_SURVEY +
            `/updateQuestionnaireFields?tenants=${this.lastSelectedTenant}`;
  
        var sendFormFieldsRequest = new Request(url, {
          method: "PATCH",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          body: JSON.stringify({
            identityType: this.identityType,
            questions: this.questionnarieFields,
          }),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var sendFormFieldsResponse = await fetch(sendFormFieldsRequest);
          if (sendFormFieldsResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendFormFieldsResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendFormFieldsResponse.status == 503) {
            return this.sendFormFields();
          }
          if (sendFormFieldsResponse.status != 200) {
            this.commandError = "Failed to send email for onboarding";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var sendFormFieldsBody = await sendFormFieldsResponse.json();
  
            this.commandError = "";
            Vue.$toast.open({
              message: "Successfully sent message for onboarding.",
              type: "success",
            });
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      async sendUpdateRules() {
        if (this.isTemperatureAlert) {
          this.checkedRules.push("Temperature Alert");
        } else {
          this.disabledRules.push("Temperature Alert");
        }
        if (this.isFallPrevention) {
          this.checkedRules.push("Fall Prevention");
        } else {
          this.disabledRules.push("Fall Prevention");
        }
        if (this.isPurposefullRounding) {
          this.checkedRules.push("Purpose-full Rounding");
        } else {
          this.disabledRules.push("Purpose-full Rounding");
        }
        if (this.isVirtualMonitor) {
          this.checkedRules.push("Virtual Monitor");
        } else {
          this.disabledRules.push("Virtual Monitor");
        }
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url = config.TENET_SERVICE + `/tenants/${this.lastTenant}/rules`;
        var sendUpdateRuleRequest = new Request(url, {
          method: "POST",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          body: JSON.stringify({
            checkedRules: this.checkedRules,
            disabledRules: this.disabledRules,
          }),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var sendUpdateRuleResponse = await fetch(sendUpdateRuleRequest);
          if (sendUpdateRuleResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendUpdateRuleResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendUpdateRuleResponse.status == 503) {
            return this.sendUpdateRules();
          }
          if (sendUpdateRuleResponse.status != 200) {
            this.commandError = "Failed to create Rules";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var sendRuleBody = await sendUpdateRuleResponse.json();
  
            this.commandError = "";
            Vue.$toast.open({
              message: "Successfully Updated Rules.",
              type: "success",
            });
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      async showFormFieldsRespose(tenant) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url =
            config.COVID_SURVEY +
            `/getQuestionnaireFields?tenants=${this.lastSelectedTenant}`;
        var fetchFormRequest = new Request(url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          // this.viewSubmissionList = true;
          var fetchFormResponse = await fetch(fetchFormRequest);
          if (fetchFormResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (fetchFormResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (fetchFormResponse.status == 503) {
            return this.showFormFieldsRespose(tenant);
          }
          if (fetchFormResponse.status != 200) {
            this.commandError = "Failed to fetch on board response";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            let getFormRespose = await fetchFormResponse.json();
  
            this.formFieldValue = getFormRespose;
            //  this.formFieldValue = [{identityType: "select", value: ""}]
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      async sendOnboarding() {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
  
        var url =
            config.TENET_SERVICE +
            `/tenants/${this.lastSelectedTenant}/onboarding?access_token=${id_token}`;
        var emails = "";
        if (this.tags.length) {
          this.tags.forEach((e) => {
            emails += e.text + ",";
          });
        }
        emails = emails.substring(0, emails.length - 1);
        var sendOnBoadingRequest = new Request(url, {
          method: "POST",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          body: JSON.stringify({
            groupName: this.SendOnboardingDocument.nameGroup,
            email: emails,
            facilityName: this.SendOnboardingDocument.facilityName,
            timeZone: this.SendOnboardingDocument.timeZone,
            sensors: this.addBudgetList,
          }),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var sendOnBoardingResponse = await fetch(sendOnBoadingRequest);
          if (sendOnBoardingResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendOnBoardingResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendOnBoardingResponse.status == 503) {
            return this.sendOnboarding();
          }
          if (sendOnBoardingResponse.status != 200) {
            this.commandError = "Failed to send email for onboarding";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var sendOnBoardingBody = await sendOnBoardingResponse.json();
  
            this.commandError = "";
            Vue.$toast.open({
              message: "Successfully sent message for onboarding.",
              type: "success",
            });
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      
      //method that prepares the changes values are send as parames to tha api call
      exportReport() {
        var csv = [];
        csv.push(
            "Facility,Location,Sensor Name,Local Date,Total,Normal,High,Low\n"
        );
        this.currentTenantWeekReport.forEach((l) => {
          var sensorList = [];
          l.activities.forEach((a) => {
            var ssl = sensorList.find(
                (sl) =>
                    sl.Facility === a.locationName &&
                    sl.Location === a.unitName &&
                    sl.SensorName === a.areaName &&
                    sl.LocalDate === l.exportDate
            );
            if (!ssl) {
              ssl = {total: 0, normal: 0, abnormal: 0, low: 0};
              ssl.Facility = a.locationName;
              ssl.Location = a.unitName;
              ssl.SensorName = a.areaName;
              ssl.LocalDate = l.exportDate;
              sensorList.push(ssl);
            }
            ssl.total += a.total;
            ssl.abnormal += a.abnormal;
            ssl.low += a.low;
            ssl.normal += a.normal;
          });
          csv.push(
              sensorList
                  .map(
                      (x) =>
                          [
                            x.Facility,
                            x.Location,
                            x.SensorName,
                            x.LocalDate,
                            x.total,
                            x.normal,
                            x.abnormal,
                            x.low,
                          ].join(",") + "\n"
                  )
                  .join("")
          );
        });
        var csvFile;
        var downloadLink;
  
        // CSV file
        csvFile = new Blob(csv, {type: "text/csv"});
  
        // Download link
        downloadLink = document.createElement("a");
  
        // File name
        downloadLink.download =
            this.selectedTenant.fullName +
            `[${this.reportDateRange[0]} to ${this.reportDateRange[this.reportDateRange.length - 1]
            } ].csv`;
  
        // Create a link to the file
        downloadLink.href = window.URL.createObjectURL(csvFile);
  
        // Hide download link
        downloadLink.style.display = "none";
  
        // Add the link to DOM
        document.body.appendChild(downloadLink);
  
        // Click download link
        downloadLink.click();
      },
      async getLocations(tenantId, id_token) {
        var locUrl =
            config.TENET_SERVICE + `/tenants/${tenantId}/locations?limit=1000`;
        var tenants_list_request = new Request(locUrl, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var tenantListResponse = await fetch(tenants_list_request);
          if (tenantListResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
  
            return;
          }
          if (tenantListResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
  
            return;
          }
          if (tenantListResponse.status == 503) {
            return this.getLocations(tenantId, id_token);
          }
          if (tenantListResponse.status != 200) {
            this.errorMessage =
                "APIs are warming up. Please refresh the page in a few seconds.";
          } else {
            var tenantsBody = await tenantListResponse.json();
  
            this.tenantLocations = tenantsBody.locations;
            this.errorMessage = "";
          }
        } catch (tex) {
          //onsole.log('Failed to get Tenant location list:',tex)
          this.errorMessage =
              "Failed to get tenant location list due to an error.";
        }
      },
      showLocationChart(location, report, days) {
        var canvas = document.getElementById("locCanvas");
        var ctx = canvas.getContext("2d");
  
        document.getElementById("subChart").style.display = "";
        document.getElementById("mainChart").style.display = "none";
        var sensorDS = {};
        var sensorList = [];
        report
            .filter((x) => x.locationName === location)
            .map((x) => x.activities)
            .forEach((x) => {
              x.forEach((y) => {
                var fqdn = y.unitName + "/" + y.areaName;
                if (sensorList.indexOf(fqdn) < 0) {
                  sensorList.push(fqdn);
                }
                var dataset = sensorDS[fqdn];
                if (!dataset) {
                  dataset = {name: y.areaName, normal: 0, abnormal: 0, low: 0};
                  sensorDS[fqdn] = dataset;
                }
                dataset.abnormal += y.abnormal;
                dataset.normal += y.normal;
                dataset.total += y.total;
                dataset.low += y.low;
              });
            });
        sensorList.sort();
        var data = {
          labels: sensorList,
          datasets: [
            {
              label: "Normal",
              backgroundColor: "#05b5da",
              stack: "Stack 0",
              data: [],
            },
            {
              label: "High",
              backgroundColor: "#f17777",
              stack: "Stack 0",
              data: [],
            },
            {
              label: "Low",
              backgroundColor: "#abacac",
              stack: "Stack 0",
              data: [],
            },
          ],
        };
        sensorList.forEach((s) => {
          var ds = sensorDS[s];
          data.datasets[0].data.push(ds.normal);
          data.datasets[1].data.push(ds.abnormal);
          data.datasets[2].data.push(ds.low);
        });
        if (canvas["cai_chart"]) {
          var chartOld = canvas["cai_chart"]; //.config.data;
          chartOld.destroy();
        }
        var chart = new Chart(ctx, {
          type: "horizontalBar",
          data: data,
          options: {
            title: {
              display: true,
              text:
                  "Temperature Report for " +
                  location +
                  ": [ " +
                  days[0] +
                  " to " +
                  days[days.length - 1] +
                  " ]",
            },
            tooltips: {
              mode: "index",
              intersect: false,
            },
            responsive: true,
            scales: {
              xAxes: [
                {
                  stacked: true,
                },
              ],
              yAxes: [
                {
                  stacked: true,
                },
              ],
            },
          },
        });
        canvas.cai_chart = chart;
        //canvas.scrollIntoView();
      },
      drawCharts(records, days) {
        document.getElementById("subChart").style.display = "none";
        document.getElementById("mainChart").style.display = "";
        var canvas = document.getElementById("canvas");
        var ctx = canvas.getContext("2d");
        var locs = this.tenantLocations
            .map((x) => x.name)
            .sort(function (a, b) {
              var nameA = a.toUpperCase(); // ignore upper and lowercase
              var nameB = b.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
  
              // names must be equal
              return 0;
            });
        var data = {
          labels: locs,
          datasets: [
            {
              label: "Normal",
              backgroundColor: "#05b5da",
              stack: "Stack 0",
              data: [],
            },
            {
              label: "High",
              backgroundColor: "#f17777",
              stack: "Stack 0",
              data: [],
            },
            {
              label: "Low",
              backgroundColor: "#abacac",
              stack: "Stack 0",
              data: [],
            },
          ],
        };
  
        locs.forEach((d) => {
          var nl = 0,
              lo = 0,
              ab = 0;
          records
              .filter((l) => l.locationName === d)
              .forEach((wr) => {
                nl += wr.normal;
                lo += wr.low;
                ab += wr.abnormal;
              });
          data.datasets[0].data.push(nl);
          data.datasets[1].data.push(ab);
          data.datasets[2].data.push(lo);
        });
        var chart = new Chart(ctx, {
          type: "bar",
          data: data,
          options: {
            title: {
              display: true,
              text:
                  "Temperature Report: [ " +
                  days[0] +
                  " to " +
                  days[days.length - 1] +
                  " ]",
            },
            tooltips: {
              mode: "index",
              intersect: false,
            },
            responsive: true,
            scales: {
              xAxes: [
                {
                  stacked: true,
                },
              ],
              yAxes: [
                {
                  stacked: true,
                },
              ],
            },
          },
        });
        var thisSvc = this;
  
        canvas.onclick = function (evt) {
          var activePoints = chart.getElementsAtEvent(evt);
          if (activePoints[0]) {
            var chartData = activePoints[0]["_chart"].config.data;
            var idx = activePoints[0]["_index"];
  
            var label = chartData.labels[idx];
            var value = chartData.datasets[0].data[idx];
            var color = chartData.datasets[0].backgroundColor[idx]; //Or any other data you wish to take from the clicked slice
  
            thisSvc.showLocationChart(label, records, days);
          }
        };
      },
      async loadTenantReports(t, id_token) {
        this.tenantStats = {total: 0, low: 0, abnormal: 0, normal: 0};
        Vue.$toast.open({
          message: "Loading reports...",
          type: "info",
          queue: true,
          position: "bottom",
        });
        let loader = Vue.$loading.show({
          // Optional parameters
          color: "skyblue",
          opacity: 0.1,
          loader: "dots",
        });
        //showGlobalOverlay('');
        this.currentTenantWeekReport = [];
        const tenantName = t;
        var daysInRange = [];
        var endOfWeek = this.startOfWeekForReport.clone().endOf("week");
        var dt = this.startOfWeekForReport.clone();
        while (dt <= endOfWeek) {
          daysInRange.push(dt.format("MM/DD/YYYY"));
          dt.add(1, "days");
        }
        this.reportDateRange = daysInRange;
        const startDate = new Date(
            this.startOfWeekForReport.clone().subtract(1, "day").utc().format()
        );
        var endDate = new Date(
            this.startOfWeekForReport.clone().add(8, "day").utc().format()
        );
        const localDay = moment().format("ddd MMM DD");
        const fiveMinutesBack = new Date(Date.now() - 5 * 60 * 1000);
        if (endDate > fiveMinutesBack) {
          endDate = fiveMinutesBack;
        }
        //var dtStart = this.startOfWeekForReport.format("YYYY-MM-DD")+"T00:00:00.000Z";
        var dtStart =
            this.startOfWeekForReport.format("YYYY-MM-DD") + "T00:00:00.000Z";
        var dtEnd = endOfWeek.format("YYYY-MM-DD") + "T00:00:00.000Z";
        var next = "limit=1000&offset=0";
        var fetchCount = 0;
        var weeklyReport = [];
        var next_on_error = null;
        while (next != null) {
          const url =
              config.REPORTS_SERVICE +
              `/tenants/${tenantName}/reports/entranceActivities/?startDate=${dtStart}&endDate=${dtEnd}&${next};`;
          next_on_error = next;
          next = null;
          var request = new Request(url, {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
          });
          var res = await fetch(request);
          if (res.status === 403) {
            this.loading = false;
            this.errorMessage =
                "Uh oh... you don't have the permission required to access this resource.";
            return;
          }
          if (res.status == 401) {
            this.loading = false;
            this.errorMessage = "Your session has expierd please login again";
            return;
          } else if (res.status === 503) {
            next = next_on_error;
            continue;
          } else if (res.status != 200) {
            this.loading = false;
            this.errorMessage = "An error occurred";
            return;
          }
          var data = await res.json();
          next = data.next;
          var records = data.records;
  
          records.forEach((x) => {
            x.localDateForExport = x.localDate; //moment.tz(x.dateIdentified, x.timezone).format("MM/DD/YYYY");
            x.localDate = x.localDate; //moment.tz(x.dateIdentified, x.timezone).format("ddd, MMM DD")
            x.localTime = x.localHour; //moment.tz(x.dateIdentified, x.timezone).format("hh:mm A");
            x.localHour = x.localHour; //moment.tz(x.dateIdentified, x.timezone).format("hh A");
            var ll = this.tenantLocations.find((l) => l.id === x.location);
            x.locationName = ll ? ll.name : null;
            if (ll && ll.units) {
              var uu = ll.units.find((u) => u.id === x.unit);
              if (uu) {
                x.unitName = uu.name;
                if (uu.areas) {
                  var aa = uu.areas.find((a) => a.id === x.area);
                  x.areaName = aa ? aa.name : null;
                }
              }
            }
            if (x.locationName && x.unitName && x.areaName) {
              var aggLoc = weeklyReport.find(
                  (i) => i.locationId === x.location && i.date === x.localDate
              );
              if (!aggLoc) {
                aggLoc = {
                  locationId: x.location,
                  date: x.localDate,
                  exportDate: x.localDateForExport,
                  activities: [],
                  total: 0,
                  abnormal: 0,
                  low: 0,
                  normal: 0,
                  locationName: x.locationName,
                };
                weeklyReport.push(aggLoc);
              }
              aggLoc.total += x.total;
              aggLoc.abnormal += x.high;
              aggLoc.normal += x.normal;
              aggLoc.low += x.low;
              x.abnormal = x.high;
  
              aggLoc.activities.push(x);
            }
          });
  
          records = records.filter((x) => daysInRange.includes(x.localDate));
          fetchCount += 1000;
          if (data.count > 0) {
            var pctg = parseInt((fetchCount * 100) / data.count);
            if (pctg > 100) {
              pctg = 99;
            }
            //Vue.$toast.open({message:'Loaded '+pctg+'%', type:'info' , duration:2000,queue:true , position:"bottom"});
            //showGlobalOverlay('');
          }
          this.currentTenantWeekReport = [
            ...this.currentTenantWeekReport,
            ...records,
          ];
        }
        weeklyReport = weeklyReport.filter((x) => daysInRange.includes(x.date));
        if (weeklyReport.length > 0) {
          this.tenantStats = weeklyReport.reduce((a, b) => ({
            total: a.total + b.total,
            low: a.low + b.low,
            abnormal: a.abnormal + b.abnormal,
            normal: a.normal + b.normal,
          }));
        }
        this.currentTenantWeekReport = weeklyReport;
        await this.drawCharts(weeklyReport, daysInRange);
        //document.getElementById('canvas').scrollIntoView();
        //alert(this.currentTenantWeekReport.length);
        loader.hide();
  
        //hideGlobalOverlay();
      },
      disablePrivacy() {
        if (this.selectedTenant) {
          if (
              confirm(
                  "Are you sure you want to disable privacy for: ",
                  this.selectedTenant.fullName
              )
          ) {
            if (
                confirm(
                    "Hey " +
                    this.$auth.user.name +
                    "! You 100% sure you want to disable privacy for: ",
                    this.selectedTenant.fullName
                )
            ) {
              this.clearTenant();
            }
          }
        }
      },
      enablePrivacy() {
        if (this.selectedTenant) {
          this.$confirm(
              "Are you sure you want to enable privacy mode for" +
              this.selectedTenant.fullName
          ).then(() => {
            this.$confirm(
                "Hey " +
                this.$auth.user.name +
                "! You 100% sure you want to enable privacy for: " +
                this.selectedTenant.fullName
            ).then(() => {
              this.clearTenant();
              //do something...
            });
            //do something...
          });
  
          //if(confirm('Are you sure you want to enable privacy for: ', this.selectedTenant.fullName)){
          //if(confirm('Hey '+ this.$auth.user.name +'! You 100% sure you want to enable privacy for: ', this.selectedTenant.fullName)){
          //this.clearTenant();
          //}
          //}
        }
      },
      clearTenant() {
        this.selectedTenant = null;
        this.tenantAction = null;
      },
      disableselectedValues(budgetList) {
        this.sensorValue.forEach((e) => {
          if (
              budgetList.length &&
              budgetList.filter((a) => a.sensorType == e.label).length
          ) {
            e.disabled = true;
          } else {
            e.disabled = false;
          }
        });
      },
      clearSensorBudget(idx) {
        this.counter--;
        this.addBudgetList.splice(idx, 1);
        this.disableselectedValues(this.addBudgetList);
      },
      addBudget() {
        let value = {
          sensorType: "",
          sensorCount: "",
        };
  
        this.addBudgetList.push(value);
  
        this.disableselectedValues(this.addBudgetList);
      },
      clearformFields(idx) {
        this.counter--;
        this.questionnarieFields.splice(idx, 1),
            this.disableselectedValues(this.questionnarieFields);
      },
      addFormFields() {
        let values = {
          questionId: "",
          question: "",
          type: "",
          validation: "",
        };
        this.questionnarieFields.push(values);
        this.disableselectedValues(this.questionnarieFields);
      },
      getName(tenant) {
        if (tenant.fullName == tenant.name) {
          return tenant.fullName;
        } else {
          return `${tenant.fullName} (${tenant.name})`;
        }
      },
      getRoutes(routes, type) {
        if (!routes) {
          return "-none-";
        } else if (type === "ROUTES_URL") {
          return routes
              .map((r) =>
                  r.type === type
                      ? '<a href="' +
                      r.key +
                      '?scope=care-ai" target="_blank">' +
                      r.key +
                      "</a><span>(" +
                      r.connectionId +
                      ")</span>"
                      : null
              )
              .filter((r) => r != null)
              .join("<br/>");
        } else {
          return routes
              .map((r) =>
                  r.type === type
                      ? "<span>" + r.key + " (" + r.connectionId + ")</span>"
                      : null
              )
              .filter((r) => r != null)
              .join("<br/>");
        }
      },
      async fetchData() {
        let loader = Vue.$loading.show({
          color: "skyblue",
          opacity: 0.1,
          loader: "dots",
        });
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var next = this.nextTenantPointer || "limit=100&offset=0";
        this.error = this.post = null;
        this.loading = true;
  
        // replace `getPost` with your data fetching util / API wrapper
        var request = new Request(config.TENET_SERVICE + `/tenants/?${next}`, {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var res = await fetch(request);
          if (res.status === 403) {
            this.loading = false;
            this.errorMessage =
                "Uh oh... you don't have the permission required to access this resource.";
          }
          if (res.status == 401) {
            this.loading = false;
            this.errorMessage = "Your session has expierd please login again";
          }
          if (res.status == 503) {
            return this.fetchData();
          }
          if (res.status != 200) {
            (this.errorMessage = "Error occurred while fetching tenant list: "),
                res.status;
            loader.hide()
            return;
          } else {
            var data = await res.json();
            if (!this.tenants) {
              this.tenants = [];
            }
            data.tenants.forEach(ele => {
              let defaultVersion = this.releaseVersions.find(e => e.defaultRelease === true);
              let chkVersion = this.releaseVersions.find(e => e.tenants.includes(ele.name))
              ele.version = chkVersion ? chkVersion.version : defaultVersion.version;
            })
            this.tenants = [...this.tenants, ...data.tenants];
            this.loading = false;
            // this.next = data.next;
            this.nextTenantPointer = data.next;
            this.counts = data.count;
            if (this.nextTenantPointer) {
              this.counts = parseInt(data.next.split("offset=")[1]);
              this.fetchData();
            }
            loader.hide()
          }
        } catch (tex) {
          loader.hide()
          this.errorMessage = "Failed to get tenant users due to an error.";
        }
      },
    },
  };
  </script>
  <style>
  .modal-title {
    margin-bottom: 0;
    line-height: 1.5;
    color: #484848;
    font-weight: 400;
    font-size: 15px;
  }
  
  .modal-header .close:focus {
    outline: none;
  }
  
  .btn-primary.focus,
  .btn-primary:focus,
  .btn-primary:not(:disabled):not(.disabled).active:focus,
  .btn-primary:not(:disabled):not(.disabled):active:focus,
  .show>.btn-primary.dropdown-toggle:focus,
  .btn-secondary.focus,
  .btn-secondary:focus {
    box-shadow: none;
  }
  
  .btn {
    border-radius: 5px;
  }
  
  .btn-primary:not(:disabled):not(.disabled).active,
  .btn-primary:not(:disabled):not(.disabled):active,
  .show>.btn-primary.dropdown-toggle {
    background: #00b5da;
    border-color: #00b5da;
  }
  
  .btn-primary {
    background: #00b5da;
    border-color: #00b5da;
  }
  
  .btn-primary:hover {
    background: #1dd8f6;
    border-color: #1dd8f6;
    color: #ffffff;
  }
  
  .btn-secondary {
    background: #f27778;
  }
  
  .btn-secondary:hover {
    background: #fc3131;
    border-color: #fc3131;
  }
  
  .btn-secondary:not(:disabled):not(.disabled).active,
  .btn-secondary:not(:disabled):not(.disabled):active,
  .show>.btn-secondary.dropdown-toggle {
    background: #fc3131;
    border-color: #fc3131;
  }
  
  .contentData {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }
  .config-list-container {
    max-height: 650px;
    width: 38%;
    margin-right: 15px;
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .tv-settings-args-edit-container {
    max-height: 650px;
    overflow: hidden;
    width: 70%;
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  </style>
  <style lang="scss">
  #updateFormFields .btn-primary {
    background-color: #50b9d4;
    border: 1px solid #50b9d4;
    outline: none;
  }
  
  #updateFormFields .btn-primary:hover {
    color: #fff;
    background-color: #1a80a8;
    border-color: #1a80a8;
  }
  
  #updateFormFields .btn-primary:focus {
    box-shadow: none;
  }
  
  #updateFormFields .modal-title {
    color: #fff;
  }
  
  #tenantModal .selectDD {
    width: 200px !important;
  }
  
  #tenantModal select {
    width: 130px !important;
    overflow: hidden !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: 1px solid #dceaea;
    outline: none;
    padding: 7px 15px;
    border-radius: 5px;
    color: #6a6a6a;
  }
  
  #updateFormFields .btn-secondary {
    background-color: #f27778;
    border: 1px solid #f27778;
    outline: none;
  }
  
  #updateFormFields .btn-secondary:hover {
    color: #fff;
    background-color: #f34243;
    border-color: #f34243;
  }
  
  #updateFormFields .btn-secondary:focus {
    box-shadow: none;
  }
  
  #updateFormFields .modal-header .close {
    outline: none;
  }
  
  #updateFormFields .close:not(:disabled):not(.disabled):focus,
  #updateFormFields .close:not(:disabled):not(.disabled):hover {
    opacity: 1;
  }
  
  .modal-content {
    border: 2px solid black !important;
  }
  
  #updateFormFields .modal-content {
    border: 1px solid #ebebeb;
  }
  
  #updateFormFields .modal-footer {
    border-top: none;
  }
  
  .update-headings .col,
  .identity-type .col-form-label {
    font-weight: bold;
    color: #1a80a8;
    padding: 5px;
  }
  
  .update-fields .col {
    padding: 5px;
  }
  
  // .flex-2{
  //   flex: 2;
  // }
  // .flex-5{
  //   flex: 5;
  // }
  #updateFormFields select {
    overflow: hidden !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: 1px solid #dceaea;
    outline: none;
    padding: 7px 15px;
    border-radius: 5px;
    color: #6a6a6a;
  }
  
  #updateFormFields .btn-danger {
    border-radius: 50%;
    width: 34px;
    background: #f27778;
    color: #fff;
  }
  
  #updateFormFields .btn-danger:hover {
    background: #dc3545;
  }
  
  #updateFormFields .btn-danger:focus {
    box-shadow: none;
  }
  
  #updateFormFields select:focus {
    box-shadow: none;
  }
  
  .update-fields .col.close,
  .update-headings .col.close {
    max-width: 32px;
    margin: 0 10px 0 0;
  }
  </style>
  <style lang="scss" scoped>
  @import "../../style.scss";
  
  body,
  html {
    font-family: GTWalsheimPro-Regular !important;
    font-size: 16px;
    overflow: hidden;
  }
  
  h3 {
    overflow: hidden;
  }
  .contentDataWrapper,
  .contentActualDataWrapper,
  .contentDataWrap {
  overflow: visible !important;
  }
  
  // canvas {
  //   -moz-user-select: none;
  //   -webkit-user-select: none;
  //   -ms-user-select: none;
  // }
  
  .next-steps {
    .fa-link {
      margin-right: 5px;
    }
  }
  
  table {
    border-collapse: collapse;
    border-left: 1px solid #999;
    border-right: 1px solid #999;
  }
  
  td,
  th {
    border-bottom: 1px solid #999;
    padding: 0.5rem;
    text-align: left;
  }
  
  th {
    background-color: #199fff;
    color: #fff;
  }
  
  .subheading {
    width: 25%;
    background-color: #9994;
    border-right: 1px solid #999;
  }
  
  /* Chart.js */
  @keyframes chartjs-render-animation {
    from {
      opacity: 0.99;
    }
  
    to {
      opacity: 1;
    }
  }
  
  .chartjs-render-monitor {
    animation: chartjs-render-animation 1ms;
  
    height: 600px;
    width: 1201px;
    margin-left: 100px;
    margin-right: 100px;
    position: absolute;
  }
  
  .chartjs-size-monitor,
  .chartjs-size-monitor-expand,
  .chartjs-size-monitor-shrink {
    position: absolute;
    direction: ltr;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
    visibility: hidden;
    z-index: -1;
    border: 1px red;
  }
  
  .chartjs-size-monitor-expand>div {
    position: absolute;
    width: 1000000px;
    height: 1000000px;
    left: 0;
    top: 0;
  }
  
  .chartjs-size-monitor-shrink>div {
    position: absolute;
    width: 200%;
    height: 200%;
    left: 0;
    top: 0;
  }
  
  .chart-legend li span {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 5px;
  }
  
  .chart-legend {
    height: 250px;
    overflow: auto;
  }
  
  .chart-legend li {
    cursor: pointer;
  }
  
  .strike {
    text-decoration: line-through !important;
  }
  
  .closeSubChart {
    position: absolute;
    right: 30vw;
    top: 330px;
    border: 1px solid #000;
    font-size: 0.7em;
    padding: 5px;
    background-color: #eaeaea !important;
    cursor: pointer;
    font-weight: bolder;
  }
  
  .closeSubChart:hover {
    text-decoration: underline;
  }
  
  .cards-container {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-auto-rows: auto;
    grid-gap: 1rem;
  }
  
  .card {
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    padding: 0.5rem;
    background-color: #5d6d7e;
    color: #fff;
  }
  
  .dashboardBlocksWrapper {
    padding: 30px 30px;
    background: blue($color: #25b8f1);
    width: 100%;
    flex-wrap: nowrap;
    position: absolute;
    top: 80px;
    border-bottom: 1px solid #e5f0f2;
  }
  
  .dashboardBlock {
    background: red;
    margin: 0 55px;
    padding: 10px;
    border-radius: 10px;
    flex-grow: 1;
    max-width: 100%;
    height: 75px;
    width: 250px;
  }
  
  .dashboardIcon {
    float: left;
    margin-right: 10px;
  }
  
  .btn {
    background: #1dd8f6;
    border-radius: 5px;
    color: #fff;
    // position:absolute;
    // top:250px;
    // left:500px;
    border-color: #1dd8f6;
    padding: 5px 10px;
    border: 0px;
  }
  
  
  .filterInputText {
    max-width: 215px !important;
    background: #575757 !important;
    outline: none !important;
    border: 1px solid #575757 !important;
    //background: rgba(255,255,255,0.5) !important;
    color: #fff !important;
    padding: 1px 15px;
  }
  
  .contentDataWrapper {
    font-family: GTWalsheimPro-Regular !important;
  
    font-size: 16px;
    //overflow-y: auto;
    overflow-x: hidden;
    font-weight: 400;
  }
  
  .contentDataWrapper.actions {
    overflow: initial !important;
  }
  
  .contentDataWrapper.actions .contentData>div.dropdownAction {
    overflow: initial !important;
  }
  
  .contentDataWrap {
    max-height: calc( 100vh - 200px );
    overflow-y: auto;
    margin-bottom: 10px;
  }
  
  .contentHeader {
    font-family: GTWalsheimPro-Regular !important;
    font-size: 16px;
    overflow-x: hidden;
    font-weight: 400;
  }
  
  .pageHeader {
    font-family: GTWalsheimPro-Regular !important;
    font-size: 20px;
    //overflow-x: hidden;
    font-weight: 400;
  }
  
  .modal-header {
    background: #50b9d4;
    color: #fff;
  }
  
  .modal-title {
    font-size: 14px !important;
  }
  
  .modal-body {
    color: #7b7b7b;
  }
  
  .modal-footer {
    background: #f2fdff;
    color: #1a80a8;
    justify-content: center;
  }
  
  .modal-footer .btn {
    padding: 5px 20px;
    border-radius: 6px;
    min-width: 100px;
    //border: 1px solid #50B9D4 !important;
  }
  
  .modal-footer .btn-primary:hover {
    background: #3288D2;
    border-color: #3288D2;
    color: #ffffff;
  }
  
  .modal-footer> :not(:last-child) {
    margin-right: 15px;
  }
  
  .modal-footer> :not(:first-child) {
    margin-left: 15px;
  }
  
  html input[disabled]~.checkmark {
    opacity: 0.5;
  }
  
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    overflow-x: hidden;
    overflow-y: auto;
  
    &__backdrop {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 1;
      font-family: "GTWalsheimPro-Regular" !important;
    }
  
    &__dialog {
      position: relative;
      width: 600px;
      background-color: #ffffff;
      border-radius: 5px;
      margin: 50px auto;
      display: flex;
      flex-direction: column;
      z-index: 2;
  
      @media screen and (max-width: 992px) {
        width: 90%;
      }
    }
  
    &__close {
      width: 30px;
      height: 30px;
    }
  
    &__header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 20px 20px 10px;
    }
  
    &__body {
      padding: 10px 20px 10px;
      overflow: auto;
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }
  
    &__footer {
      padding: 10px 20px 20px;
    }
  }
  
  .rectangle {
    height: 1000px;
    width: 1000px;
    background-color: red;
  }
  
  h6 {
    position: absolute;
    top: 230px;
    left: 1400px;
  }
  
  .filterDropDownData,
  .actionDropDownData {
    padding: 0;
    border-radius: 0;
    top: 21px !important;
    border: 1px solid #e5f0f2;
    z-index: 1000 !important;
  }
  
  .scrollable-container {
    overflow-y: scroll;
    max-height: 700px;
  }
  
  .box-color {
    background: #f2fdff;
  
    color: #1a80a8;
  }
  
  .actionDropDownData {
    top: 10px !important;
    min-width: 300px !important;
    background: #fff !important;
    border-radius: 5px !important;
    max-width: 300px !important;
    border: 0px solid #e5f0f2;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  }
  
  .actionDropDown {
    background: #1dd8f6 !important;
    border-radius: 5px;
    color: #fff !important;
    float: left;
    padding: 5px 25px;
    text-align: left;
    width: auto !important;
    padding: 0 30px 0 20px !important;
    height: 40px !important;
    line-height: 40px;
    position: relative;
  }
  
  .actionDropDown:after {
    position: absolute;
    top: 18px;
    right: 15px;
  }
  
  .flex-2 {
    flex: 2 !important;
  }
  
  .flex-3 {
    flex: 3 !important;
  }
  
  .actionDropDown:hover {
    text-decoration: none;
  }
  
  .actionWrapper {
    padding: 10px 0;
  }
  
  .actionWrapperRow {
    padding-bottom: 5px;
    margin-bottom: 5px !important;
    border-bottom: 1px solid #dceaea;
  }
  
  .actionWrapperRow:last-child {
    padding-bottom: 0;
    /*margin-bottom: 0 !important;*/
    border-bottom: 0px solid;
  }
  
  .actionWrapperRow .actionWrapperRowHeading {
    color: #808f96;
    font-size: 15px;
    font-family: GTWalsheimPro-Regular;
    letter-spacing: 0px;
    opacity: 1;
  }
  
  .actionBtn.settingBtn {
    border-radius: 30px 30px 30px 30px;
  }
  
  .actionBtn.clientShowBtn {
    border-radius: 5px;
    min-width: 80px;
    text-align: center !important;
    display: inline-grid;
    background: #00b5da;
    color: #fff;
    line-height: 36px;
    padding: 0 15px;
    cursor: pointer;
    font-size: 15px;
    background:#575757;
  }
  
  .actionBtn.clientShowBtn:hover {
    background: #1dd8f6;
    color: #ffffff;
  }
  
  .actionBtn.deviceShowBtn {
    border-radius: 30px;
    min-width: 80px;
    text-align: center !important;
    padding: 0;
    display: inline-grid;
    background: #00b5da;
    color: #fff;
  }
  
  .actionBtn.active {
    background: #50b9d4;
    color: #fff;
    border: 1px solid #50b9d4;
  }
  
  .actionBtn.showBtn {
    background: #50b9d4;
    color: #fff;
    border: 1px solid #50b9d4;
  }
  
  .actionBtn.hideBtn {
    background: #daf9ff;
    color: #50b9d4;
    border: 1px solid #daf9ff;
  }
  
  .filterDropDownData>a:last-child::after,
  .filterDropDownData>a.active::after,
  .filterDropDownData>a:hover:after,
  .actionDropDownData>a:last-child::after,
  .actionDropDownData>a.active::after,
  .actionDropDownData>a:hover:after {
    display: none;
  }
  
  .contentData>div .actionDropDown {
    background: transparent;
    border: 1px solid #dedede;
    color: #6a6a6a;
    box-shadow: none !important;
    outline: none !important;
    width: auto;
    padding: 5px 15px;
  }
  
  .container {
    position: absolute;
    height: 600px;
    max-width: 96%;
    margin-left: 30px;
    //margin-right:60px;
    top: 260px;
  
    display: table;
    background-color: white;
  }
  
  .container.border {
    border: 2px solid #dee2e6 !important;
  }
  
  .pageActualDataWrapper {
    max-height: calc(100vh - 160px);
  }
  
  // .contentActualDataWrapper{
  //   height:100%;
  //   max-height: calc( 100vh - 160px );
  //   overflow-x:auto;
  // }
  // .filterWrapper{
  //     background: #1dd8f6;
  //     display: inline-flex;
  //     padding: 5px 15px;
  //     font-size: 16px;
  //     min-width: 250px;
  //     border-radius: 5px;
  //     margin-left: 15px;
  //     max-width: 250px;
  //     line-height: 25px;
  // }
  .align-items-right {
    align-items: flex-end;
  }
  
  .version-link:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #00bfff;
  }
  
  .version-link {
    color: rgb(84, 84, 251);
    text-decoration: underline;
  }
  
  // .modal-dialog .onboarding-modal {
  //   //width: 600px;
  //   //height: 600px;
  //   max-width: 650px !important;
  //   max-height: 600px !important;
  // }
  .modal-dialog {
    width: 700px !important;
    max-width: 0 !important;
  }
  
  .tfilters {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 15px;
  }
  
  .custom-modal-dialog {
    width: 700px !important;
    max-width: 0 !important;
  }
  
  .modal-dialog .modal-md .custom-modal-dialog {
    width: 700px !important;
    max-width: none !important;
  }
  
  /* Style for the fieldset element */
  .group-contents {
    border: 2px solid #d1cfcf;
    /* Border color and width */
    border-radius: 5px;
    /* Rounded corners */
    padding: 10px;
    /* Padding around the content */
    margin: 20px 0;
    /* Margin above and below the fieldset */
  }
  
  /* Style for the legend element (the title of the fieldset) */
  .group-contents legend {
    font-weight: bold;
    /* Bold text */
    font-size: 18px;
    /* Larger text size */
    color: #d43d3d;
    /* Text color */
    padding: 5px 10px;
    /* Padding around the legend text */
    border-radius: 5px;
    /* Rounded corners for the legend */
  }
  
  .shipt-selection {
    color: darkgray;
    font-size: 12px;
  }
  
  .in-valid {
    border-color: #dc1414 !important;
  }
  
  .valid {
    border-color: 1px solid #7a8991 !important;
  }
  
  .modal-form-group-wrapper {
    color: #6a6a6a;
  
  }
  
  ::v-deep .btn-secondary {
    border-color: #1dd8f6;
  }
  
  ::v-deep .btn-secondary:hover {
    border-color: #f27778;
    background: #f27778;
  }
  #samlConnectionSetupModal {
    .custom-form-label {
      color: #3288D2;
      font-family: GTWalsheimPro-Regular !important;
      font-size: 16px;
      font-weight: 400;
    }
  
    .modal-content {
      max-width: 600px;
    }
  }
  

  
  
  ::v-deep #samlConnectionSetupModal .modal-dialog .modal-content {
    border: none !important;
    -webkit-box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
    -moz-box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
    box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
  }
  
  ::v-deep #samlConnectionSetupModal .modal-dialog {
    max-width: 600px;
  }
  .filterWrapper {
      background: #575757;
      display: inline-flex;
      padding: 1px 15px;
      font-size: 15px;
      min-width: 360px;
      max-width: 360px;
      border-radius: 5px;
      margin-left: 10px;
      align-items: center;
      text-overflow: ellipsis;
  }
  .filterText{
    opacity:1;
  }
  #tenantModal .modal-dialog{
    max-width: 420px;
  }
   
  
  
  </style>
  
  
  